import { render, staticRenderFns } from "./ChatSideBarSetReply.vue?vue&type=template&id=5a8dab40&scoped=true&"
import script from "./ChatSideBarSetReply.vue?vue&type=script&lang=js&"
export * from "./ChatSideBarSetReply.vue?vue&type=script&lang=js&"
import style0 from "./ChatSideBarSetReply.vue?vue&type=style&index=0&id=5a8dab40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8dab40",
  null
  
)

export default component.exports